import { useNavigate } from "react-router-dom";
import styles from "./Start.module.css";
import logospeedorder from '../../../images/novalogo_speedorder.svg';
import logo_uni_eat from '../../../images/UniEatLogo.svg'

function Start() {
    const navigate = useNavigate();

    const handleComecar = () => {
        // Verifica se o usuário já está logado
        const nomeUsuario = localStorage.getItem("nome_usuario");
        const tipoUsuario = localStorage.getItem("tipo_usuario");

        if (nomeUsuario) {
            // Já logado → vai direto para a home correta
            if (tipoUsuario === "cliente") {
                navigate("/homecliente");
            } else {
                navigate("/home");
            }
        } else {
            // Não logado → vai para a tela de login
            navigate("/home");
        }
    };

    return (
        <main className={styles.mainStart}>
            <div className={styles.welcomesession}>
                <img src={logospeedorder} alt="SpeedOrder" className={styles.marcaSpeedOrder} />

                <div className={styles.produtos}>
                    <div className={styles.produtoCard}>
                        <span className={styles.produtoIcone}>
                            <img src={logo_uni_eat} alt="" className={styles.produtoLogoImg} />
                        </span>
                        <span className={styles.produtoNome}>UniEat</span>
                        <span className={styles.produtoDesc}>Lanchonetes universitárias</span>
                    </div>

                    <span className={styles.produtoDivider} aria-hidden="true">+</span>

                    <div className={styles.produtoCard}>
                        <span className={styles.produtoIcone} aria-hidden="true">🍽️</span>
                        <span className={styles.produtoNome}>EatOrder</span>
                        <span className={styles.produtoDesc}>Restaurantes parceiros</span>
                    </div>
                </div>

                <p className={styles.textoChamada}>
                    Peça na sua universidade com o UniEat ou em restaurantes parceiros com o EatOrder — tudo em um só app, rápido e prático.
                </p>

                <button className={styles.botaoiniciar} onClick={handleComecar}>
                    Começar
                </button>
            </div>
        </main>
    );
}

export default Start;
